"use strict";

var _jsxRuntime = require("react/jsx-runtime");
module.exports = ({
  title,
  titleId,
  size,
  color,
  ...props
}) => /*#__PURE__*/(0, _jsxRuntime.jsxs)("svg", {
  ...props,
  viewBox: "0 0 24 24",
  height: size,
  width: size,
  fill: color,
  role: title ? 'img' : undefined,
  "aria-hidden": !title,
  "aria-labelledby": titleId,
  children: [title ? /*#__PURE__*/(0, _jsxRuntime.jsx)("title", {
    id: titleId,
    children: title
  }) : null, /*#__PURE__*/(0, _jsxRuntime.jsx)("path", {
    fillRule: "evenodd",
    d: "M20.5 13a7.5 7.5 0 1 1-15 0 7.5 7.5 0 0 1 15 0Zm1.5 0a9 9 0 1 1-17.999 0A9 9 0 0 1 22 13Zm-6.527 3.482a.749.749 0 1 0 1.058-1.057l-2.449-2.445 2.449-2.446a.748.748 0 0 0-1.058-1.057l-2.449 2.446-2.458-2.454a.748.748 0 0 0-1.058 1.057l2.458 2.455-2.5 2.494a.748.748 0 0 0 1.058 1.056l2.5-2.494",
    clipRule: "evenodd"
  })]
});